import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { AWS_S3 } from "../../Constants"

function ZdqAwsS3ConnectorStatus() {
    return <ZdqConnectorStatus vendor={AWS_S3}></ZdqConnectorStatus>
}

export default ZdqAwsS3ConnectorStatus